import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import AudioUploader from './AudioUploader';
import AudioDownloader from './AudioDownloader';
import { RandomizedText } from '../App';

const HomePage = ({ onNavigate, onProcessed, processedFilename, onReset }) => {
  return (
    <>
      <RandomizedText
        variant="h4"
        component="h1"
        gutterBottom
        sx={{
          maxWidth: '80%',
          mx: 'auto',
          mb: 3,
          fontWeight: 500,
          textAlign: 'center',
        }}
      >
        POV: You're crying in the bathroom listening to...
      </RandomizedText>
      {!processedFilename ? (
        <AudioUploader onProcessed={onProcessed} />
      ) : (
        <AudioDownloader filename={processedFilename} onReset={onReset} />
      )}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Link
          onClick={() => onNavigate('/feed')}
          color="secondary"
          sx={{
            cursor: 'pointer',
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textUnderlineOffset: '4px',
            textDecorationColor: 'rgba(138, 152, 157, 0.5)',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          or, check out what others have been listening to...
        </Link>
      </Box>
    </>
  );
};

export default HomePage;
